import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getAlgoListDataCachedSelectedDay } from '../../../../stores/algos-list/getters';
import { toggleAlgo } from '../../../../stores/algos-list/actions';
import { addNotification } from '../../../../actions/notifications';
import Toggle from '../../../../components/light-weight/Toggle';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .progress': {
      marginLeft: 10,
      display: 'flex',
      '& .MuiCircularProgress-indeterminate': {
        animationDuration: '0.65s',
      },
    },
  },
}));

const CellEnabled = ({ row = {} }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;

  const enabled = useSelector((state) => {
    const algos = getAlgoListDataCachedSelectedDay(state) || [];

    const { enabled = false } = algos.find((d) => d._id === _id) || {};

    return enabled;
  });

  const status = useSelector((state) => {
    const algos = getAlgoListDataCachedSelectedDay(state) || [];

    const { status = '' } = algos.find((d) => d._id === _id) || {};

    return status;
  });

  const enabledLoading = useSelector((state) => {
    const algos = getAlgoListDataCachedSelectedDay(state) || [];

    const { enabledLoading = false } = algos.find((d) => d._id === _id) || {};

    return enabledLoading;
  });

  const handleElgoToggle = async () => {
    try {
      const targetState = !enabled;

      const { isSuccess = false } = await dispatch(
        toggleAlgo(_id, targetState)
      );

      if (isSuccess) {
        dispatch(
          addNotification({
            type: 'success',
            message: `Algo ${
              targetState ? 'enabled' : 'disabled'
            } successfully`,
          })
        );

        if (status === 'TRADE_ACTIVE' || status === 'READY') {
          return;
        }
      }
    } catch (err) {
      if (err && err.message && err.message === 'Network Error') {
        dispatch(
          addNotification({
            type: 'error',
            message: 'Algo Toggle failed',
          })
        );
      }
    }
  };

  return (
    <div className={classes.root}>
      {enabledLoading ? (
        <div className="progress">
          <CircularProgress disableShrink size={22} thickness={5} />
        </div>
      ) : (
        <Toggle checked={enabled} onChange={handleElgoToggle} />
      )}
    </div>
  );
};

export default CellEnabled;
